export function isFacebookUserAgent() {
  // cspell: ignore fban fbav
  return typeof navigator === "undefined" ? false : /fban|fbav/i.test(navigator.userAgent);
}
